import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FnLoaderType } from '../../constant/fn-loader.enum';

/**
 * Service to set Loader to Mannual or Auto And to Show And hide Loader.
 */
@Injectable()
export class FnLoaderService {

    /**
     * Loader type of fn loader service
     */
    private loaderType = new BehaviorSubject<FnLoaderType>(FnLoaderType.AUTO);
    /**
     * BehaviorSubject object emit its current value whenever it is subscribed to by providing initial value.
     */
    private isLoading = new BehaviorSubject(false);
    /**
     * Creates an instance of fn loader service.
     */
    constructor() { }

    /**
     * Show Loader
     */
    public show() {
        this.isLoading.next(true);
    }
    /**
     * Hide Loader
     */
    public hide() {
        this.isLoading.next(false);
    }

    /**
     * Check Loader is manual mode
     * @returns- {boolean}
     *
     */
    public get ISMANUALMODE(): boolean {
        let isManual = false;
        const type = this.loaderType.getValue();
        isManual = (type === FnLoaderType.MANUAL) ? true : false;
        return isManual;
    }

    /**
     * Check Loader is Auto mode
     * @returns- {boolean}
     *
     */
    public get ISAUTOMODE(): boolean {
        let isAuto = false;
        const type = this.loaderType.getValue();
        isAuto = (type === FnLoaderType.AUTO) ? true : false;
        return isAuto;
    }

    /**
     * Get Loading status
     * @returns- Obervable{boolean}
     *
     */
    public get ISLOADING(): Observable<boolean> {
        return this.isLoading;
    }

    /**
     * Set Loader Type i.e Manual / Auto
     *
     */
    public setloaderType(type: FnLoaderType) {
        this.loaderType.next(type);
    }
}
